module.exports = __webpack_public_path__ + "static/media/video-placeholder.0e166044.png";